/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var calculateTilePricePerM2 = function calculateTilePricePerM2(product, price) {
    if (!price) {
      price = product.price;
    }
    console.log('calculateTilePricePerM2');
    if (product?.meta?.product && product.meta.product['product-tilesperm2'] ) {
      
      if ( product?.meta?.custom && product.meta.custom['tiles_per_box_'] ){

        if ( product.option1.includes('tile') ){
          var per_m2 = Number(product.meta.product['product-tilesperm2']);
          price = price * per_m2;
        
        } else {
          var per_box = Number(product.meta.custom['tiles_per_box_']);
          var per_m2 = Number(product.meta.product['product-tilesperm2']);
          var multiplier = per_m2 / per_box;
    
          price = price * multiplier; 
        }
        
      } else {
          var per_m2 = Number(product.meta.product['product-tilesperm2']);
          price = price * per_m2;
      }
      
    }
    return price;
  }

  var formatPrice = function formatPrice(value, product) {

    console.log('formatPrice');
    var pricePerM2 = calculateTilePricePerM2(product, value);
    if (Shopify.currency.active === 'USD') {
      var inc_vat = Number(pricePerM2);
    } else {
      var inc_vat = Number(pricePerM2) * 1.2;
    }
    return algolia.formatMoney(inc_vat * 100);
    
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio, text, product) {
    
    var comparing = Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '<b>' + formatPrice(price, product) + '</b>';
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price, product) +
        '</span></span> ';
      res +=
        ' <span class="ais-hit--price-discount" style="font-weight: ' +
        Math.floor(discount_ratio * 10) * 100 +
        ';">-' +
        Math.floor(discount_ratio * 100) +
        '%</span>';
    }

    if (product?.meta?.details && product.meta.details['custom_unit']){
        var custom_unit = product.meta.details['custom_unit'];
        return res + " / " + custom_unit;
    } else {
      if ( product?.meta?.custom && product.meta.custom['tiles_per_box_'] ) {
        if (Shopify.currency.active === 'USD') {
           return res + " / Per sq ft";
        } else {
           return res + " / Per m2"; 
        } 
      } else {
        if ( product?.meta?.product && product.meta.product['product-tilesperm2'] ){
          if (Shopify.currency.active === 'USD') {
             return res + " / Per sq ft";
          } else {
             return res + " / Per m2"; 
          } 
        } else {
           if ( product.variant_title === "Box" ){
              return res + " / Per Box";
           } else {
              return res + " / Per Tile";
           } 
        }
      }
    }

    if (text && product?.meta?.product && product.meta.product['product-tilesperm2']) {
      return text.replace('', res);
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text), this);
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text), this).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice(t) {
      //if (this._distinct) {
      //  var min = this.variants_min_price;
      //  var max = this.variants_max_price;
      //  if (min !== max) {
      //    return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
      //  }
      //}

      return formattedPriceWithComparison(
        this.price,
        null,
        null,
        t,
        this
      );
    },
    instantsearchPrice: function instantsearchPrice(t) {
      //if (this._distinct) {
      //  var min = this.variants_min_price;
      //  var max = this.variants_max_price;
      //  if (min !== max) {
      //    return '<b>' + formatPrice(min)+ '</b>';
      //  }
      //}
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio,
        t,
        this
      );
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      //if (
      //  !this._distinct &&
      //  this.variant_title &&
      //  this.variant_title !== 'Default Title' &&
      //  this.variant_title !== 'Default'
      //) {
      //  res += ' <span class="algolia-variant">(' + res + ')</span>';
      //}
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },


    /* CUSTOM HELPERS */
    variantData: function (t, render) {
      return render(JSON.stringify(this));
    },

    expressDelivery: function (t, render) {
      if (this.meta?.details?.express_delivery)
        return render(t);

      return '';
    },

    groupName: function (t, render) {
      var name = t;
      if (this.meta?.linked_products?.group_name)
        name = this.meta.linked_products.group_name;
      return render(name);
    },

    badgeText: function (t, render) {
      var name = t;
      if (this.meta?.custom?.product_badge)
        name = this.meta.custom.product_badge;
      return render(name);
    },

    groupColour: function (t, render) {
      var colour = t;
      if (this.meta?.linked_products?.group_colour)
        colour = this.meta.linked_products.group_colour;
      return render(colour);
    },

    groupTextColour: function (t, render) {
      var colour = t;
      if (this.meta?.linked_products?.group_text_colour)
        colour = this.meta.linked_products.group_text_colour;
      return render(colour);
    },

    selectedOptions: function (t, render) {
      var options = {};
      for (var key of Object.keys(this.options)) {
        var k = key.charAt(0).toUpperCase() + key.slice(1);
        options[k] = this.options[key];
      }

      return render(JSON.stringify(options));
    },

    productSwatches: function (t, render) {
      var tpl = '<div class="product-item__swatches js-product-swatches">##</div>';
      var swatches = '';
      var linked_products = this.meta && this.meta.linked_products;

      if (!linked_products)
        return null;

      swatches += '<script type="text/html" active="true">gid://shopify/Product/' + this.id + '</script>';

      for (let i=1; i<5; i++) {
        if (!linked_products['product_' + i])
          continue;

        swatches += '<script type="text/html">' + linked_products['product_' + i] + '</script>';
      }

      return render(tpl.replace('##', swatches));
    },

    hoverImage: function (t, render) {
      try {
        if (this.named_tags.image_2) {
          return render('background-image: url(' + this.named_tags.image_2.replace(/\/(.*)\.(\w{2,4})/g, '/$1_large.$2') + ');background-size: cover;background-position: center;');
        }
      } catch {
        return '';
      }
    },

    hasHoverImage: function (t, render) {
      try {
        if (this.named_tags.image_2) {
          return render(' has-hover-image');
        }
      } catch {
        return '';
      }
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);